import { render, staticRenderFns } from "./DatosLegalesTab.vue?vue&type=template&id=f78a4790&scoped=true"
import script from "./DatosLegalesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosLegalesTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DatosLegalesTab.vue?vue&type=style&index=0&id=f78a4790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78a4790",
  null
  
)

export default component.exports